import { SvgIconProps } from '@mui/material';

import { StyledSVG } from './StyledSVG';

export function ArbolLogoSVG(props: SvgIconProps) {
  return (
    <StyledSVG
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 141 54"
      {...props}
    >
      <path
        d="M33.04 17v-4.29h2.67c2.084 0 3.344-1.26 3.344-3.105S37.794 6.5 35.71 6.5h-3.945V17h1.275Zm0-9.36h2.67c1.484 0 2.04.93 2.04 1.965 0 1.035-.556 1.965-2.04 1.965h-2.67V7.64Zm10.505 9.48c2.25 0 3.855-1.635 3.855-3.9 0-2.28-1.605-3.9-3.855-3.9-2.235 0-3.84 1.62-3.84 3.9 0 2.265 1.605 3.9 3.84 3.9Zm0-1.08c-1.545 0-2.61-1.17-2.61-2.82S42 10.4 43.545 10.4c1.56 0 2.625 1.17 2.625 2.82s-1.065 2.82-2.625 2.82Zm7.939.96 1.845-6.015L55.189 17h1.155l2.295-7.56h-1.215l-1.665 6-1.83-6h-1.17l-1.86 6-1.665-6h-1.2L50.329 17h1.155Zm13.777-2.43c-.24.945-1.02 1.485-2.25 1.485-1.425 0-2.46-1.11-2.55-2.67h5.91c.015-.105.03-.36.03-.525 0-2.01-1.32-3.54-3.525-3.54-2.22 0-3.6 1.635-3.6 3.855 0 2.16 1.5 3.945 3.735 3.945 1.875 0 3.21-1.005 3.465-2.55H65.26Zm-2.385-4.23c1.35 0 2.205.81 2.295 2.085h-4.65c.225-1.335 1.08-2.085 2.355-2.085Zm9.355-.9h-.96c-1.11 0-1.74.495-2.055 1.53V9.44h-1.2V17h1.2v-3.33c0-1.785.435-3.165 1.965-3.165h1.05V9.44Zm6.477 5.13c-.24.945-1.02 1.485-2.25 1.485-1.425 0-2.46-1.11-2.55-2.67h5.91c.015-.105.03-.36.03-.525 0-2.01-1.32-3.54-3.525-3.54-2.22 0-3.6 1.635-3.6 3.855 0 2.16 1.5 3.945 3.735 3.945 1.875 0 3.21-1.005 3.465-2.55h-1.215Zm-2.385-4.23c1.35 0 2.205.81 2.295 2.085h-4.65c.225-1.335 1.08-2.085 2.355-2.085Zm8.35 6.78c1.066 0 2.056-.54 2.506-1.365V17h1.2V6.335h-1.2v4.335c-.45-.81-1.44-1.35-2.505-1.35-2.355 0-3.645 1.695-3.645 3.9s1.29 3.9 3.645 3.9Zm.106-1.08c-1.515 0-2.52-1.11-2.52-2.82 0-1.71 1.005-2.82 2.52-2.82 1.515 0 2.505 1.11 2.505 2.82 0 1.71-.99 2.82-2.505 2.82Zm12.974 1.08c2.355 0 3.645-1.695 3.645-3.9s-1.29-3.9-3.645-3.9c-1.065 0-2.04.54-2.505 1.35V6.335h-1.2V17h1.2v-1.245c.465.825 1.455 1.365 2.505 1.365Zm-.105-1.08c-1.515 0-2.505-1.11-2.505-2.82 0-1.71.99-2.82 2.505-2.82 1.53 0 2.52 1.11 2.52 2.82 0 1.71-.99 2.82-2.52 2.82Zm9.781-6.6-2.145 6-2.145-6h-1.245l2.82 7.68-.96 2.94h1.155l1.38-4.095 2.4-6.525h-1.26ZM132.882 41.655l-.078-6.011-.078-6.011-2.691-.043-2.69-.042V46.26h12.642l-.043-2.225-.043-2.225-3.51-.078-3.509-.078Z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M115.022 29.874c1.661.547 2.742 1.212 3.804 2.34 1.533 1.627 2.282 3.496 2.277 5.688-.005 2.406-.77 4.293-2.412 5.953-1.385 1.4-2.825 2.137-4.838 2.479-1.764.3-2.694.3-4.233.006-3.336-.639-6.045-3.055-6.837-6.097-.304-1.17-.306-3.336-.003-4.5a8.29 8.29 0 0 1 5.463-5.78c1.977-.64 4.988-.68 6.779-.09Zm-3.743 4.203c-1.164.227-2.266 1.155-2.775 2.337-.361.838-.317 2.447.088 3.23.795 1.537 1.804 2.245 3.196 2.245 1.991 0 3.411-1.486 3.522-3.688.048-.945-.005-1.265-.325-1.96-.755-1.642-2.163-2.465-3.706-2.164ZM92.798 29.9c1.617.479 2.685 1.209 3.298 2.256.92 1.573.32 3.7-1.318 4.66-.44.257-.802.515-.805.572-.003.058.251.19.565.294.843.278 1.824 1.345 2.232 2.426 1.004 2.663-.641 5.141-3.928 5.917-.765.18-2.156.232-6.322.234l-5.342.002v-8.249c0-4.537.052-8.302.117-8.367.064-.065 2.503-.086 5.42-.047 4.052.055 5.487.126 6.083.302Zm-5.973 4.924.046 1.21h1.574c1.691 0 1.993-.111 2.27-.842.194-.51-.083-1.171-.587-1.401-.213-.097-1.053-.177-1.868-.177h-1.48l.045 1.21Zm0 6.168.046 1.288 1.68-.024c1.859-.026 2.37-.214 2.55-.937.166-.658-.114-1.202-.724-1.412-.299-.102-1.23-.19-2.07-.195l-1.527-.009.045 1.288ZM70.438 29.998c2.852.938 4.165 2.92 3.991 6.027-.108 1.94-.525 2.988-1.611 4.049-.465.454-.844.878-.844.943 0 .065.675 1.218 1.501 2.564a651.214 651.214 0 0 1 1.569 2.563c.037.064-1.345.117-3.07.117h-3.139l-.997-2.108-.999-2.108h-2.196V46.268l-2.769-.042-2.768-.043-.043-7.963c-.024-4.38-.004-8.127.045-8.328l.089-.366 5.102.065c4.725.06 5.177.09 6.138.407Zm-5.728 3.977c-.043.113-.059 1.009-.034 1.991l.044 1.786 1.014.05c1.624.078 2.327-.084 2.915-.673.433-.433.516-.631.516-1.225 0-1.673-.613-2.132-2.851-2.133-1.115 0-1.547.055-1.604.204ZM46.519 29.688c.11.07.715 1.386 1.344 2.925.629 1.538 2.135 5.203 3.347 8.144 1.212 2.94 2.204 5.382 2.204 5.425 0 .043-1.329.079-2.953.079-2.926 0-2.954-.003-3.061-.351a31.75 31.75 0 0 0-.412-1.171l-.303-.82H43.58c-2.172 0-2.905-.042-3.278.304-.234.217-.327.587-.546 1.218l-.285.82h-2.855c-1.57 0-2.854-.02-2.854-.043 0-.09 6.95-16.282 7.068-16.468.144-.225 5.343-.282 5.689-.063Zm-3.487 6.854a82.36 82.36 0 0 1-.795 2.135c-.201.508-.365 1.017-.365 1.132 0 .159.379.207 1.628.207.896 0 1.66-.053 1.698-.117.09-.152-1.481-4.567-1.626-4.567-.06 0-.303.544-.54 1.21Z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m13.214 31.235-2.493 4.31 4.135-2.342 2.472-4.162-4.114 2.194Zm-.052-.071 4.263-2.274.058.061-2.558 4.307-.016.016-4.285 2.427-.06-.06 2.58-4.46.018-.017Z"
        fill="#fff"
        stroke="#fff"
        strokeWidth=".5"
        strokeLinejoin="bevel"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m14.858 33.257.022-.082 5.153.004.023.007 4.3 2.658-.024.081-5.209-.193-.02-.006-4.245-2.47Zm.185.006 4.094 2.382 5.033.186-4.15-2.564-4.977-.004Z"
        fill="#fff"
        stroke="#fff"
        strokeWidth=".5"
        strokeLinejoin="bevel"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m17.41 28.906.038-.021 5.116.11.037.066-2.536 4.241-.038.021-5.138-.043-.037-.066 2.558-4.308Zm.062.067-2.506 4.22 5.036.043 2.485-4.156-5.015-.107ZM19.092 35.707l.039-.066 5.225.197.037.023 2.362 4.46-.042.064-4.985-.306-.034-.021-2.602-4.351Zm.116.024 2.549 4.262 4.884.3-2.313-4.369-5.12-.193Z"
        fill="#fff"
        stroke="#fff"
        strokeWidth=".5"
        strokeLinejoin="bevel"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m22.524 29.015.058-.016 4.483 2.383.016.062-2.71 4.46-.06.015-4.308-2.602-.015-.06 2.537-4.242Zm.054.081-2.492 4.168 4.232 2.557 2.665-4.383-4.405-2.342ZM21.688 40.034l.047-.042 4.985.306.04.042.175 4.744-.045.045-5.313-.196-.042-.045.153-4.854Zm.086.048-.15 4.765 5.222.193-.171-4.657-4.9-.301Z"
        fill="#fff"
        stroke="#fff"
        strokeWidth=".5"
        strokeLinejoin="bevel"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m24.386 35.883 2.335 4.392 2.637-4.395-2.314-4.37-2.658 4.373Zm-.088-.024 2.711-4.46.076.002 2.361 4.46v.043l-2.69 4.482-.076-.002-2.383-4.482.001-.043ZM21.543 44.866l.038-.02 5.313.196.036.067-2.69 4.242-.037.02-5.248-.131-.036-.067 2.624-4.307Zm.06.068-2.57 4.22 5.147.13 2.635-4.157-5.211-.193Z"
        fill="#fff"
        stroke="#fff"
        strokeWidth=".5"
        strokeLinejoin="bevel"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m26.76 40.375.168 4.57 2.302-4.287.127-4.59-2.597 4.307Zm-.082-.034 2.69-4.46.08.023-.13 4.767-.006.02-2.383 4.437-.082-.019-.175-4.744.006-.024ZM18.93 49.16l.025-.007 5.248.14.02.082-4.176 2.33-.02.006-5.182.165-.025-.08 4.11-2.636Zm.037.08L15 51.783l5.013-.16 4.027-2.246-5.075-.137ZM21.71 40.068l-2.529-4.213-.073 4.671 2.433 4.21.168-4.668Zm.087-.01-.175 4.832-.081.02-2.515-4.35-.005-.023.075-4.837.082-.022 2.613 4.356.006.024Z"
        fill="#fff"
        stroke="#fff"
        strokeWidth=".5"
        strokeLinejoin="bevel"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m18.95 40.652-4.118 2.28-2.629 4.436 4.271-2.336 2.476-4.38Zm.152-.092-2.558 4.526-.017.016-4.422 2.419-.058-.06 2.716-4.584.016-.016 4.264-2.36.059.059Z"
        fill="#fff"
        stroke="#fff"
        strokeWidth=".5"
        strokeLinejoin="bevel"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.616 44.867v.045l-2.602 4.285h-.075l-2.485-4.121v-.044l2.572-4.515h.076l2.514 4.35Zm-.088.022-2.464-4.263-2.522 4.427 2.435 4.037 2.55-4.201ZM14.822 42.856l.038.066-2.75 4.602-.038.021-5.044-.185-.036-.066 2.654-4.46.038-.022 5.138.044Zm-.077.087L9.71 42.9l-2.604 4.375 4.944.182 2.696-4.514Z"
        fill="#fff"
        stroke="#fff"
        strokeWidth=".5"
        strokeLinejoin="bevel"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m19.037 49.152-.014.06-4.154 2.667-.06-.014-2.76-4.359.015-.062 4.407-2.429.059.016 2.507 4.12Zm-.097.009-2.463-4.05-4.33 2.388 2.712 4.282 4.08-2.62ZM9.686 42.862l.015.06-2.633 4.417-.059.015-4.32-2.493-.016-.06 2.667-4.59.061-.016 4.285 2.667Zm-.082.052-4.21-2.621-2.624 4.514 4.245 2.45 2.589-4.343Z"
        fill="#fff"
        stroke="#fff"
        strokeWidth=".5"
        strokeLinejoin="bevel"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m14.882 51.818-.038.068-5.072-.11-.037-.02-2.76-4.428.038-.066 5.074.177.035.02 2.76 4.36Zm-.118-.022-2.704-4.27-4.968-.174 2.705 4.337 4.967.107ZM5.417 40.211v.043l-2.668 4.592-.077-.002-2.339-4.416v-.043l2.624-4.547h.077l2.383 4.373Zm-.089.02L2.994 35.95.422 40.408l2.29 4.325 2.616-4.502Z"
        fill="#fff"
        stroke="#fff"
        strokeWidth=".5"
        strokeLinejoin="bevel"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m6.98 47.338-4.132-2.384 2.844 4.297 3.947 2.352-2.66-4.265Zm.068-.056 2.76 4.427-.06.061-4.11-2.449-.014-.013-2.951-4.46.058-.062 4.302 2.481.015.015ZM2.95 35.849l-.19-4.592-2.28 4.308-.063 4.675 2.533-4.391Zm.082.032L.41 40.43l-.082-.023.066-4.853.005-.02 2.361-4.46.082.018.197 4.767-.006.023Z"
        fill="#fff"
        stroke="#fff"
        strokeWidth=".5"
        strokeLinejoin="bevel"
      />
      <path
        d="m9.663 42.856 5.182.044-4.107-2.348-5.36-.32 4.285 2.624Z"
        stroke="#fff"
        strokeWidth=".5"
        strokeLinejoin="bevel"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m9.675 42.812 5.003.043-3.953-2.26-5.175-.309 4.125 2.526Zm-.035.081L5.355 40.27l.026-.081 5.36.32.018.005 4.107 2.348-.022.081-5.181-.043-.023-.007Z"
        fill="#fff"
        stroke="#fff"
        strokeWidth=".5"
        strokeLinejoin="bevel"
      />
      <path
        d="m8.14 36.111 2.587 4.456v-4.91L8.11 31.29l.03 4.821Z"
        stroke="#fff"
        strokeWidth=".5"
        strokeLinejoin="bevel"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m10.77 40.567-.08.022-2.588-4.456-.006-.022-.03-4.82.082-.024 2.617 4.367.006.023v4.91Zm-.087-.163V35.67l-2.528-4.22.029 4.65 2.5 4.306Z"
        fill="#fff"
        stroke="#fff"
        strokeWidth=".5"
        strokeLinejoin="bevel"
      />
      <path
        d="m2.995 35.86 2.383 4.372 5.36.32-2.546-4.464-5.197-.229Z"
        stroke="#fff"
        strokeWidth=".5"
        strokeLinejoin="bevel"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m5.376 40.276-.036-.023-2.383-4.373.04-.064 5.197.229.037.022 2.545 4.463-.04.065-5.36-.32Zm.029-.086 5.255.313-2.493-4.372-5.096-.224 2.334 4.283Z"
        fill="#fff"
        stroke="#fff"
        strokeWidth=".5"
        strokeLinejoin="bevel"
      />
      <path
        d="M10.822 26.94 8.11 31.29l2.611 4.364 2.453-4.436-2.352-4.279Z"
        stroke="#fff"
        strokeWidth=".5"
        strokeLinejoin="bevel"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m10.721 35.567 2.405-4.35-2.306-4.191-2.657 4.265 2.558 4.276Zm-.036.11-2.611-4.364v-.046l2.712-4.35.075.001 2.353 4.279v.042l-2.453 4.436-.076.002Z"
        fill="#fff"
        stroke="#fff"
        strokeWidth=".5"
        strokeLinejoin="bevel"
      />
      <path
        d="m2.797 31.093.197 4.766 5.197.23-.081-4.799-5.313-.197Z"
        stroke="#fff"
        strokeWidth=".5"
        strokeLinejoin="bevel"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m2.754 31.095.045-.045 5.313.196.042.043.081 4.799-.045.044-5.198-.229-.041-.042-.197-4.766Zm.09.044.192 4.679 5.111.225-.08-4.71-5.224-.194Z"
        fill="#fff"
        stroke="#fff"
        strokeWidth=".5"
        strokeLinejoin="bevel"
      />
      <path
        d="m14.945 24.218-4.124 2.743 2.353 4.257 4.272-2.29-2.501-4.71Z"
        stroke="#fff"
        strokeWidth=".5"
        strokeLinejoin="bevel"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m13.195 31.256-.059-.017-2.352-4.257.014-.057 4.124-2.743.063.016 2.5 4.71-.017.06-4.273 2.288Zm-.003-.097 4.196-2.248-2.458-4.63-4.05 2.694 2.312 4.184Z"
        fill="#fff"
        stroke="#fff"
        strokeWidth=".5"
        strokeLinejoin="bevel"
      />
      <path
        d="m5.486 26.83-2.69 4.263 5.314.197 2.733-4.373-5.357-.087Z"
        stroke="#fff"
        strokeWidth=".5"
        strokeLinejoin="bevel"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m8.088 31.245 2.679-4.285-5.255-.086-2.636 4.178 5.212.193Zm.022.089-5.313-.197-.035-.067 2.69-4.264.037-.02 5.356.088.037.067-2.733 4.372-.039.02Z"
        fill="#fff"
        stroke="#fff"
        strokeWidth=".5"
        strokeLinejoin="bevel"
      />
      <path
        d="m19.96 24.403-5.006-.175 2.492 4.7 5.117.11-2.602-4.635Z"
        stroke="#fff"
        strokeWidth=".5"
        strokeLinejoin="bevel"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m17.446 28.972-.038-.023-2.492-4.7.04-.065 5.007.175.036.022 2.602 4.636-.039.065-5.116-.11Zm.027-.087 5.014.108-2.552-4.547-4.907-.172 2.445 4.611Z"
        fill="#fff"
        stroke="#fff"
        strokeWidth=".5"
        strokeLinejoin="bevel"
      />
      <path
        d="m10.844 26.961 4.111-2.733-5.313.262-4.176 2.34 5.378.131Z"
        stroke="#fff"
        strokeWidth=".5"
        strokeLinejoin="bevel"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m10.83 26.917 3.968-2.637-5.144.254-4.028 2.256 5.205.127Zm.012.088-5.378-.131-.02-.082 4.176-2.34.02-.005 5.312-.263.026.08-4.11 2.733-.026.008Z"
        fill="#fff"
        stroke="#fff"
        strokeWidth=".5"
        strokeLinejoin="bevel"
      />
      <path
        d="m22.564 29.038 4.482 2.383-2.908-4.504-4.176-2.514 2.602 4.635Z"
        stroke="#fff"
        strokeWidth=".5"
        strokeLinejoin="bevel"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m22.543 29.077-.018-.018-2.601-4.635.06-.058 4.176 2.514.014.014 2.908 4.503-.057.063-4.482-2.383Zm.052-.072 4.323 2.299-2.812-4.354-4.025-2.424 2.514 4.48Z"
        fill="#fff"
        stroke="#fff"
        strokeWidth=".5"
        strokeLinejoin="bevel"
      />
    </StyledSVG>
  );
}
